module.exports = __webpack_public_path__ + "img/activesuite1.31960689.jpg";